import React from 'react';
import styled from '@emotion/styled';
import { i18n_next_episode_arrives } from '@yi/i18n/phrases/i18n_next_episode_arrives';

import { formatDate } from '~/common';
import type { Season } from '~/src/common/lean-back';
import { useLocale } from '~/src/components/LocaleProvider';

interface Props {
  nextEpisodeDate: Season['next_episode_release_date'];
}

const Card = styled.div`
  width: 300px;
  min-height: 200px;
  background: #26292e;
  color: #e0e0e1;
  display: flex;
  justify-content: center;
  align-items: center;
  white-space: pre-wrap;
  text-align: center;
  padding: 20px;
`;

export const NextEpisodeCard: React.FC<Props> = ({ nextEpisodeDate }) => {
  const { locale } = useLocale();

  // Only render if date exists, and is in the future
  if (!nextEpisodeDate || new Date(nextEpisodeDate.iso8601).getTime() < Date.now()) return null;

  return (
    <Card>
      <span>
        {i18n_next_episode_arrives(locale, { date: formatDate(nextEpisodeDate.iso8601, locale) })}
      </span>
    </Card>
  );
};
